module.exports = __webpack_public_path__ + "static/media/TL_Eink_A2(G8)_wT-CON (T2000)_LD-240751_240719.8cb795cc.pdf";